class Settings {
  static DEVELOP = 0;
  static STAGING = 1;
  static PRODUCTION = 2;

  static ENV = Settings.PRODUCTION;

  static SERVER_URLS = {
    0: "http://localhost:8000/",
    //2: "http://ec2-13-39-114-205.eu-west-3.compute.amazonaws.com/",
    2: "https://terra.orbitaleos.com/",
  };

  static SERVER_IPS = {
    0: "127.0.0.1:8000",
    //2: "ec2-13-39-114-205.eu-west-3.compute.amazonaws.com",
    2: "terra.orbitaleos.com",
  };

  static BASE_URL = Settings.SERVER_URLS[Settings.ENV];
  static BASE_IP = Settings.SERVER_IPS[Settings.ENV];
}

export default Settings;
